export const constants = {
  Blocked: {
    tables: ["MemberReview"],
    columns: {
      BlockedHygienist: [
        "id",
        "dentistId",
        "practiceName",
        "hygienistId",
        "firstName",
        "lastName"
      ],
      BlockedDentist: ["id"],
      FavouriteHygienist: [
        "id",
        "dentistId",
        "locationId",
        "practiceName",
        "hygienistId",
        "firstName",
        "lastName"
      ],
      FavouriteDentist: ["id"],
      Location: ["id"],
      Shift: ["id"],
      User: ["id"]
    }
  },
  fieldsToFormat: ["blockedUntil", "startDate", "stripeCreatedTimestamp"],
  fieldsToUTC: ["postedStart", "postedEnd"],
  tables: {
    SNCBillingBoard: "SNCBillingBoard",
    MemberReview: "MemberReview",
    FirstShiftBooked: "FirstShiftBooked",
    Hygienist: "Hygienist",
    DailyShiftList: "DailyShiftList",
    Invoice: "Invoice",
    Location: "Location",
    Job: "Job",
    Shift: "Shift",
    User: "User",
    default: "Tables"
  },
  // Tables fetched a page at a time via getPaginateItems rather than dumped
  // whole by getData. The generic `Tables` component cannot page, so anything
  // listed here also needs an entry in `tables` above pointing at its own
  // component (T2-6968).
  serverPaginateTables: [
    "Job",
    "Hygienist",
    "Location",
    "Shift",
    "Invoice",
    "User"
  ],
  enabledColumns: {
    jobTable: [
      "id",
      "dentistId",
      "locationId",
      "offersCount",
      "hygienistId",
      "bookedOn",
      "hourlyRate",
      "status",
      "Instabook",
      "Autobook",
      "fraudDetectionTimestamp",
      "fraudDetectionReason",
      "dentistRating",
      "hygienistRating",
      "dentistBilled",
      "startDate",
      "originalTimes",
      "currentTimes",
      "actualStart",
      "actualEnd",
      "dentistPrivateNotes",
      "hygienistPrivateNotes",
      "type",
      "requiredLevel",
      "paymentTerms",
      "paymentMethod",
      "firstBooked"
    ],
    blockedhygienistTable: [
      "id",
      "dentistId",
      "practiceName",
      "hygienistId",
      "firstName",
      "lastName"
    ],
    hygienistTable: [
      "id",
      "firstName",
      "lastName",
      "address",
      "city",
      "province",
      "postalCode",
      "country",
      "phone",
      "CDHONumber",
      "starScore",
      "school",
      "graduationYear",
      "blockedUntil",
      "completedJobs",
      "numCancelled",
      "maxBooked",
      "type",
      "resumeUrl",
      "maxRate",
      "blacklistReason",
      "Notes",
      "status",
      "accountStatus",
      "valueGives",
      "stripeAccountId",
      "stripeCreatedTimestamp",
      "Verified",
      "etransferEmail",
      "isDupe",
      "notificationsLevel",
      "WeeklyNewsletter",
      "PriorityNotifications",
      "receivePostedShifts",
      "createdOn",
      "photoUrl",
      "about"
    ],
    locationTable: [
      "id",
      "dentistId",
      "loginEmail",
      "deactivated",
      "email",
      "secondaryEmail",
      "practiceName",
      "primaryContact",
      "city",
      "province",
      "country",
      "postalCode",
      "isReliable",
      "accountingEmail",
      "phone",
      "address",
      "Notes",
      "isCentralBooked",
      "placementFees",
      "defaultProposedRateHygienist",
      "defaultProposedRateAssistant",
      "stripeCustomerId",
      "revenueStripeCustomerId",
      "lat",
      "lon",
      "regionId",
      "photoUrl",
      "createdOn"
    ],
    // Searchable columns for Location table (backend whitelist)
    locationTableSearch: [
      "loginEmail",
      "email",
      "practiceName",
      "primaryContact",
      "city",
      "province",
      "phone",
      "address",
      "notes"
    ],
    blockedhygienistTableSearch: [
      "dentistId",
      "practiceName",
      "hygienistId",
      "firstName",
      "lastName"
    ],
    // Searchable columns for Hygienist table (backend whitelist)
    hygienistTableSearch: [
      "firstName",
      "lastName",
      "city",
      "province",
      "phone",
      "CDHONumber",
      "Notes"
    ],
    // Searchable columns for Job table (backend whitelist)
    // Note: Only ID columns are used for search to match user requirements
    // Backend expects these with j. prefix (added in mixin)
    jobTableSearch: [
      "id",
      "dentistId",
      "locationId",
      "hygienistId"
    ],
    // Searchable columns for Shift table (backend whitelist)
    // Note: Backend expects these with s. prefix for Shift columns, j. prefix for Job columns
    shiftTableSearch: ["id", "jobId", "locationId"],
    // T2-6968: AP /tables/User. Mirrors the six columns Admin.getUserList
    // selects. User also holds password / credentials / verificationToken /
    // resetPasswordToken — never add those here or to the API query.
    userTable: [
      "id",
      "email",
      "dentistId",
      "hygienistId",
      "TokenAmount",
      "accountStatus"
    ],
    // Sent to the backend unchanged (the mixin only prefixes Job and Shift).
    // Unqualified is correct: getUserList selects `FROM User u` with no JOIN, so
    // these resolve unambiguously, and all four are already in the paginator's
    // allowedColumns.
    userTableSearch: ["id", "email", "dentistId", "hygienistId"],
    memberReview: [
      "id",
      "firstName",
      "lastName",
      "address",
      "city",
      "country",
      "postalCode",
      "province",
      "CDHONumber",
      "phone",
      "email",
      "status",
      "graduationYear",
      "type",
      "resumeUrl",
      "createdOn",
      "isDupe"
    ],
    shiftTable: [
      "id",
      "jobId",
      "shiftDate",
      "postedStart",
      "postedEnd",
      "actualStart",
      "actualEnd",
      "type",
      "totalHours",
      "unpaidHours",
      "billableHours",
      "modifiedOn",
      "gapUnpaid",
      "remindStatus",
      "locationId",
      "timezone"
    ],
    invoiceTable: [
      "id",
      "jobId",
      "locationId",
      "hygienistId",
      "totalHours",
      "totalUnpaidHours",
      "totalBillableHours",
      "hourlyRate",
      "totalInvoiceAmt",
      "hygienistMarkedPaid",
      "dentistMarkedPaid",
      "sent",
      "createdOn",
      "sentOn",
      "paidOn",
      "manualHygienistId",
      "manualDentistId",
      "nonPaymentReportedOn",
      "creditPaid",
      "travelAllowance",
      "notes",
      "unresolved",
      "resolved",
      "ticketLinks",
      "hygienistEmail",
      "officeEmail",
      "officePhone",
      "firstName",
      "lastName",
      "practiceName",
      "isCentralBooked",
    ],
    firstShiftBooked: [
      "JobId",
      "HygienistId",
      "firstName",
      "lastName",
      "address",
      "city",
      "country",
      "postalCode",
      "province",
      "CDHONumber",
      "locationName",
      "primaryContact",
      "hygienistEmail",
      "dentistEmail",
      "status",
      "resumeUrl",
      "graduationYear",
      "type",
      "ShiftDate",
      "postedStart",
      "firstBooked",
      "phone"
    ],
    dailyShiftList: [
      "id",
      "jobId",
      "shiftDate",
      "postedStart",
      "type",
      "country",
      "First Name",
      "Last Name",
      "Temp Phone",
      "Temp Email",
      "Practice Name",
      "Practice Phone",
      "Practice Email",
      "shift completed by temp",
      "cancelled shifts by the temp",
      "Cancelled"
    ],
    sncBillingBoardTable: [
      "id",
      "jobId",
      "shiftDate",
      "reason",
      "details",
      "beginTimestamp",
      "cancelTimestamp",
      "bookedOn",
      "hygienistId",
      "firstName",
      "lastName",
      "practiceName",
      "dentistId",
      "hourlyRate",
      "locationId",
      "email",
      "rebooked",
      "rebookedLocationId"
    ],
    noteTable: [
      "id",
      "createdOn",
      "modifiedOn",
      "entityId",
      "type",
      "note",
      "source"
    ],
    feedbackTable: [
      "jobId",
      "clinicalSkillsRating",
      "clinicalSkillsDetails",
      "professionalismRating",
      "professionalismDetails",
      "communicationRating",
      "communicationDetails",
      "timeManagementRating",
      "timeManagementDetails",
      "rateSatisfactionRating",
      "rateSatisfactionDetails",
      "additionalFeedbackDetails",
      "createdOn",
      "modifiedOn"
    ]
  },
  tableInDialog: {
    shiftsInFSB: ["id", "startDate", "postedStart", "postedEnd", "locationId", "practiceName"],
    offersInJob: [
      "status",
      "hygienistId",
      "hygienistName",
      "isPartialOffer",
      "hourlyRate",
      "numViews",
      "firstViewed",
      "lastViewed"
    ]
  },
  statusCodes: [
    { code: "0C0", explanation: "Free Cancellation Course Requested" },
    { code: "75C0", explanation: "$75 Cancellation Course Requested" },
    { code: "150C0", explanation: "$150 Cancellation Course Requested" },
    { code: "300C0", explanation: "$300 Cancellation Course Requested" },
    { code: "600C0", explanation: "$600 Cancellation Course Requested" },
    { code: "0C1", explanation: "Free Cancellation Course Completed" },
    { code: "75C1", explanation: "$75 Cancellation Course Completed" },
    { code: "150C1", explanation: "$150 Cancellation Course Completed" },
    { code: "300C1", explanation: "$300 Cancellation Course Completed" },
    { code: "600C1", explanation: "$600 Cancellation Course Completed" },
    { code: "0R0", explanation: "Free Reinstatement Course Requested" },
    { code: "75R0", explanation: "$75 Reinstatement Course Requested" },
    { code: "150R0", explanation: "$150 Reinstatement Course Requested" },
    { code: "300R0", explanation: "$300 Reinstatement Course Requested" },
    { code: "600R0", explanation: "$600 Reinstatement Course Requested" },
    { code: "0R1", explanation: "Free Reinstatement Course Completed" },
    { code: "75R1", explanation: "$75 Reinstatement Course Completed" },
    { code: "150R1", explanation: "$150 Reinstatement Course Completed" },
    { code: "300R1", explanation: "$300 Reinstatement Course Completed" },
    { code: "600R1", explanation: "$600 Reinstatement Course Completed" }
  ],
  countryCode: {
    0: "CA",
    1: "USA"
  },
  userAccountStatuses: {
    [-4]: "Deleted",
    [1]: "Active"
  } as Record<number, string>,
  USER_STATUSES: {
    DELETED: -4,
    ACTIVE: 1
  },
  userStatusLabels: {
    [-4]: "Deleted",
    [1]: "Active"
  } as Record<number, string>,
  hygienistType: {
    0: "Hygienist",
    1: "Assistant",
    2: "Admin",
    3: "Associate Dentist"
  },
  HYGIENIST_STATUSES: {
    DEACTIVATED: -4,
    REVOKED: -3,
    BLACKLISTED: -2,
    PROBATION: -1,
    ACTIVE: 0,
    PRO: 1,
    ELITE: 2
  },
  keepStatus: {
    0: "Normal",
    1: "Keep Status On"
  },
  /**
   * Admin role constants
   * Role 0: Regular admin
   * Role 1: Developer/Super admin - has access to dev tools and advanced features
   */
  ADMIN_ROLES: {
    REGULAR: 0,
    DEVELOPER: 1
  },
  adminRoleLabels: {
    0: "Regular Admin",
    1: "Developer"
  } as Record<number, string>,
  isCentralBooked: {
    0: "Regular Office",
    1: "DentalCorp",
    2: "123D"
  } as Record<number, string>,
  // T2-5821: Human-readable labels for the Job.dentistBilled column so support
  // agents see "Regularly Charged" instead of the raw 0/1/2 values.
  dentistBilledLabels: {
    0: "Not Billed",
    1: "Regularly Charged",
    2: "Free Placement Used"
  } as Record<number, string>
};
